import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import { union, remove } from 'lodash'

import './Search.scss'
import SearchResults from './components/SearchResults'
import MyAliadasList from './components/MyAliadasList'
import Loader from 'components/Loader'
import SearchMobileNavBar from './components/SearchMobileNavBar'

import { analytics } from '@src/services/Analytics'
import { formatDate } from 'utils/dates'
import * as qs from 'utils/querystring'
import * as paths from 'utils/paths'
import { user } from 'utils/auth'
import { userPreferences, serviceTypes } from '@src/globals'

class Search extends Component {
  constructor (props) {
    super(props)
    this.onFilterChange = this.onFilterChange.bind(this)
    this.setSearchForInvoice = this.setSearchForInvoice.bind(this)
    this.configureSetup = this.configureSetup.bind(this)
    this.reserveAliada = this.reserveAliada.bind(this)
  }

  componentDidMount () {
    const {
      location: { search: querystring },
      search,
      searchMyAliadas,
      updateService
    } = this.props

    search(querystring)
    searchMyAliadas(querystring)

    const service = this.convertQueryStringToService(querystring)
    updateService({ service })
  }

  componentWillReceiveProps (nextProps) {
    // This will happen when the sort order or service type is changed
    const shouldSearchAgain = this.props.location.search !== nextProps.location.search
    if (shouldSearchAgain) {
      this.props.search(nextProps.location.search)
      this.props.searchMyAliadas(nextProps.location.search)
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const prevQueryobject = qs.parse(prevProps.location.search)
    const queryobject = qs.parse(this.props.location.search)

    const serviceTypeIdChanged = prevQueryobject.serviceTypeId !== queryobject.serviceTypeId
    if (serviceTypeIdChanged) {
      this.handleServiceTypeIdChange(queryobject.serviceTypeId)
    }
  }

  handleServiceTypeIdChange (serviceTypeId) {
    this.props.updateService({
      service: {
        serviceTypeId
      }
    })
  }

  onFilterChange (e) {
    const { name, value } = e.target

    const queryobject = qs.parse(this.props.location.search)
    queryobject[name] = value

    if (value === '') {
      delete queryobject[name]
    }

    const url = this.props.location.pathname + qs.stringify(queryobject)
    this.props.replace(url)
  }

  setSearchForInvoice (e) {
    const wantsToEnablePreference = e.target.checked
    const queryobject = qs.parse(this.props.location.search)

    if (!queryobject.preferences) {
      queryobject.preferences = []
    }

    if (wantsToEnablePreference) {
      queryobject.preferences = union(queryobject.preferences, [userPreferences.OFFICES.slug])
    } else {
      remove(queryobject.preferences, x => x === userPreferences.OFFICES.slug)
    }

    const url = this.props.location.pathname + qs.stringify(queryobject)
    this.props.replace(url)
  }

  configureSetup () {
    const convertSearchToSetup = (querystring) => {
      const queryobject = qs.parse(querystring)
      const {
        neighborhood: label,
        coordinates: {
          latitude: lat,
          longitude: lng
        }
      } = queryobject

      delete queryobject.neighborhood
      delete queryobject.coordinates

      queryobject.location = {
        label,
        location: {
          lat,
          lng
        }
      }

      const arrayToObject = (values) => values.reduce((acc, value) => {
        acc[value] = true
        return acc
      }, {})

      queryobject.skills = queryobject.skills && arrayToObject(queryobject.skills)
      queryobject.preferences = queryobject.preferences && arrayToObject(queryobject.preferences)
      queryobject.estimatedHours = parseInt(queryobject.estimatedHours)
      queryobject.time = parseInt(queryobject.time.split(':')[0])

      return queryobject
    }

    const querystring = this.props.location.search
    const setup = convertSearchToSetup(querystring)
    this.props.updateServiceSetup(setup)
  }

  goToAliadaProfile (aliadaId) {
    const querystring = this.props.location.search
    const queryobject = qs.parse(querystring)
    const url = paths.aliadaProfile(aliadaId, queryobject)
    this.props.push(url)
  }

  renderAdminTools () {
    const {
      preferences,
      aliadaId
    } = qs.parse(this.props.location.search)

    return (
      <div>
        <div>
          <span style={{marginRight: 10}}>Factura:</span>

          <input
            name='preferences[offices]'
            type='checkbox'
            checked={!!preferences && preferences.includes('offices')}
            onChange={this.setSearchForInvoice}
            />
        </div>

        {window.aliada && window.aliada.aliadas &&
          <div>
            <span style={{marginRight: 10}}>Aliada:</span>
            <select
              name='aliadaId'
              value={aliadaId || ''}
              onChange={e => this.goToAliadaProfile(e.target.value)}
              >
              <option value={''}>Elige una Aliada</option>

              {
                window.aliada.aliadas.map(aliada => (
                  <option key={aliada.id} value={aliada.id}>{aliada.name} - {aliada.id}</option>
                ))
              }
            </select>
          </div>
        }
      </div>
    )
  }

  convertQueryStringToService (querystring) {
    const validKeys = [
      'neighborhood',
      'serviceTypeId',
      'estimatedHours',
      'aliadaId',
      'date',
      'time',
      'promotionalCode',
      'weekdays'
    ]
    const queryobject = qs.parse(querystring)
    const service = Object.keys(queryobject).reduce((acc, key) => {
      const isValidKey = validKeys.indexOf(key) !== -1
      if (isValidKey) {
        acc[key] = queryobject[key]
      }

      return acc
    }, {})

    if (service.serviceTypeId !== serviceTypes.MULTIPLE.id) {
      delete service.weekdays
    }

    return service
  }

  reserveAliada (aliadaId) {
    const {
      updateService,
      push
    } = this.props

    updateService({
      service: {
        aliadaId
      }
    })

    analytics.aliadaChosenSubmit({ aliadaId })

    const reserveStepUrl = paths.aliadaReserveAddress(aliadaId)
    push(reserveStepUrl)
  }

  render () {
    const {
      searching,
      searchingMyAliadas,
      results,
      status,
      myAliadasResults,
      location,
      goBack
    } = this.props

    const {
      sort: sortOrder,
      estimatedHours,
      neighborhood,
      date,
      time,
      coordinates,
      skills,
      preferences,
      serviceTypeId
    } = qs.parse(location.search)
    const datetime = `${date} ${time}`
    const formattedDatetime = formatDate('D MMM[, ]h[:]mma', datetime)

    const searchProps = {
      neighborhood,
      coordinates: {
        latitude: parseFloat(coordinates.latitude, 10),
        longitude: parseFloat(coordinates.longitude, 10)
      },
      estimatedHours: parseInt(estimatedHours, 10),
      serviceTypeId: parseInt(serviceTypeId, 10),
      date,
      time,
      skills,
      preferences
    }

    return (
      <div className='Search navbar-screen'>
        <SearchMobileNavBar
          leftControl={
            <Link to={paths.serviceSetup()}>
              <span className='icon-arrow-back' />
            </Link>
          }
        >
          {neighborhood}
        </SearchMobileNavBar>

        <div className='navbar-screen-content'>
          <div className='navbar-screen-container'>
            <div className='Search-filters'>
              {
                user.isOperations() && this.renderAdminTools()
              }

              <div className='Search-filtersControls'>
                <div>
                  <Link
                    to={paths.serviceSetupStep(2)}
                    className='Search-filtersDateTime'
                    onClick={this.configureSetup}>
                    {formattedDatetime}
                    <span className='icon-calendar' />
                  </Link>
                </div>

                <div className='Search-filtersSortOrder'>
                  <select
                    name='sort'
                    value={sortOrder}
                    onChange={this.onFilterChange}>
                    <option value={'by_finished_services'}>Recomendadas</option>
                    <option value={'by_rating'}>Mayor calificación</option>
                    <option value={'by_ascending_price_per_hour'}>Menor precio</option>
                    <option value={'by_descending_price_per_hour'}>Mayor precio</option>
                  </select>
                </div>
              </div>
            </div>

            {
              !searching && !searchingMyAliadas && myAliadasResults.length > 0 &&
                <MyAliadasList
                  aliadas={myAliadasResults}
                  searchProps={searchProps}
                  reserveAliada={this.reserveAliada}
                  />
            }

            {
              searching
                ? <Loader text='Buscando' />
                : <SearchResults
                  results={results}
                  status={status}
                  searchProps={searchProps}
                  reserveAliada={this.reserveAliada}
                  configureSetup={this.configureSetup}
                  />
            }

            <div className='Search-modifyService'>
              <Link to={paths.serviceSetupStep(1)} className='btn btn-default btn-block btn-lg' onClick={this.configureSetup}>
                <span className='Search-modifyServiceChevron'>‹</span> Cambiar tu servicio
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Search.displayName = 'Search'
Search.propTypes = {
  searching: PropTypes.bool.isRequired,
  results: PropTypes.array.isRequired,
  status: PropTypes.string.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired
  }).isRequired,
  search: PropTypes.func.isRequired,
  replace: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired
}
Search.defaultProps = {
  results: [],
  location: {
    search: ''
  }
}

export default Search



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/Search/Search.js